import { StartMeetingResponse } from '@vendasta/meetings';
import { MeetingInfo } from '../meeting-services/interfaces/service-interfaces';

export function constructMeetingInfo(data: StartMeetingResponse): MeetingInfo {
  return <MeetingInfo>{
    startMeetingURL: data.url,
    joinURL: data.joinURL,
    meetingPassword: data.password,
    hasError: false,
  };
}
